import axios from "axios";
import { API_ENDPOINT, TOKEN_KEY } from "../config";
// import Cookies from "universal-cookie";

// const cookies = new Cookies();
// let token = sessionStorage.getItem(TOKEN_KEY);

const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

export const getProductList = async () => {
  let token = sessionStorage.getItem(TOKEN_KEY);
  let res = await axios({
    method: "GET",
    url: `${API_ENDPOINT}product/list`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const handleUpdateProductStatus = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}product/update_status`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const handleUpdateProductStockStatus = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}product/update_stock_status`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const addProduct = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  for (var key in data) {
    if (key === "images_of_product") {
      for (let i = 0; i < data["images_of_product"].length; i++) {
        fd.append("images_of_product[]", data["images_of_product"][i]);
      }
    } else if (Array.isArray(data[key])) {
      fd.append(key, JSON.stringify(data[key]));
    } else {
      fd.append(key, data[key]);
    }
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}product/create`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
export const editProduct = async (data) => {
  let fd = new FormData();
  for (var key in data) {
    if (key === "images_of_product") {
      for (let i = 0; i < data["images_of_product"].length; i++) {
        fd.append("images_of_product[]", data["images_of_product"][i]);
      }
    } else if (Array.isArray(data[key])) {
      fd.append(key, JSON.stringify(data[key]));
    } else {
      fd.append(key, data[key]);
    }
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}product/update`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const deleteProduct = async (id) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  fd.append("id", id);
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}product/delete`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
